export const WS_CONNECTION_FAILED = 'WS_CONNECTION_FAILED';
